import axios from 'axios'
import store from '@/store';
const instance = axios.create({
    // baseURL: 'http://api.novigodemo.com/',
    headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*'
    }
})


instance.interceptors.request.use(
    (config) => {
        // console.log("store", store.state.selectedFacility.id)
        let token = store.state.oidcStore.access_token;

        if (store.state.selectedFacility) {
            let facilityId = store.state.selectedFacility.id
            config.headers['FacilityID'] = facilityId;
        }
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;

        }
        console.log('GPS : > ', store.state.settings.apiShareLink);
        config.baseURL = store.state.settings.apiShareLink;
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default instance;